module.exports = __webpack_public_path__ + "img/04.fda1b4cd.jpg";